import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/@auth/auth.service';
import { lastValueFrom } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { AppInfos, AuthSessionDto, CLU_MOBILE_INTERFACE } from 'src/app/app.models';
import { MfaLoginService } from '../mfa-login/mfa-login.service';
import { AuthUtils } from 'src/app/utils/auth.utils';
import { RenewExpiredPasswordService } from '../renew-expired-password/renew-expired-password.service';
import moment from 'moment';
import { CluExpLicenceDialogComponent } from 'src/app/utils/clu-explicence-dialog/clu-explicence-dialog.component';
import { CluConfirmDialogService } from 'src/app/utils/clu-confirm-dialog/clu-confirm-dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { CluNF525RequirementsDialogComponent } from 'src/app/utils/clu-nf525requirements-dialog/clu-nf525requirements-dialog.component';

const LS_BE_AUTH_USERNAME_KEY = 'LS_BE_AUTH_USERNAME_KEY';
const LS_BE_NF525REQUIREMENTS_ACK_KEY = 'LS_BE_NF525REQUIREMENTS_ACK_KEY';

@Component({
  selector: 'be-login',
  templateUrl: './be-login.component.html',
})
export class BELoginComponent {
  isTestEnv = false;
  options = this.settings.getOptions();
  loading = false;
  errorText: string | null = null;
  appVersion: AppInfos;
  form = new FormGroup({
    Username: new FormControl('', [Validators.required]),
    Password: new FormControl('', [Validators.required]),
  });

  constructor(
    private settings: CoreService,
    private router: Router,
    private authService: AuthService,
    private mfaLoginService: MfaLoginService,
    private renewExpiredPasswordService: RenewExpiredPasswordService,
    private appService: AppService,
    private _confirmationService: CluConfirmDialogService,
    private _matDialog : MatDialog
  ) {
    this.appVersion = appService.appVersion$.value;

    const localUsername = localStorage.getItem(LS_BE_AUTH_USERNAME_KEY);
    if (!!localUsername) {
      this.f.Username.patchValue(localUsername);
    }
    this.isTestEnv = this.appService.isBackendTestEnv;
  }

  get f() {
    return this.form.controls;
  }

  async submit() {
    if (this.form.invalid) { return; }

    this.errorText = null;
    this.loading = true;
    const username = this.f.Username.value!;
    const password = this.f.Password.value!;

    try {
      let token = await this.authService.doAuthenticateAdminAction(username, password);
      const claims = AuthUtils.parseJwt(token);
      if (claims.MFA_ENABLED == '1') {
        token = await this.mfaLoginService.show({ AccessToken: token, CluInterface: CLU_MOBILE_INTERFACE.BACKOFFICE });
        if (!token) {
          throw "";
        }
      }

      const authSessionDto = await this.authService.doGetAuthAdminSession(token);
      if (authSessionDto?.HAS_DEFAULT_PASSWORD === true) {
        const isPasswordRenewed = await this.renewExpiredPasswordService.show({ AccessToken: token });
        if (!isPasswordRenewed) {
          throw "Mot de passe non initialisé";
        }
      }

      localStorage.setItem(LS_BE_AUTH_USERNAME_KEY, username);
      this.authService.saveAuthenticationSession(authSessionDto);
      const isRunnerConfigurated = await this.appService.isRunnerConfigurated(authSessionDto.AccessToken);
      await this.router.navigateByUrl(!isRunnerConfigurated ? '/cluadmin/apps/p-admin/adm-sage-link': '/cluadmin/apps/p-admin/adm-sites');
      this.doOpenCluExpLicenceDialogIfNeededAction_BELogin(authSessionDto);

      console.log(authSessionDto);
      this.doOpenCluNF525RequirementsDialogIfNeededAction_BELogin(authSessionDto);
      this.loading = false;

    } catch(e: any) {
      this.f.Password.patchValue('');
      this.errorText = e;
      this.loading = false;
    }
  }

  private doOpenCluExpLicenceDialogIfNeededAction_BELogin(_authSessionDto : AuthSessionDto){
    const _daysLeft = moment.utc(_authSessionDto.LICENCE_DATE_EXPIRATION).diff(moment(), 'days');
    if(_daysLeft > 60) return;
    this._matDialog.open(CluExpLicenceDialogComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: '600px', minHeight: '80vh', maxHeight: '80vh', height : '100%', data : {  authSessionDto : _authSessionDto, daysLeft : _daysLeft } })
        .afterClosed()
        .subscribe((res : any) => { if(res){ } });
  }


  private doOpenCluNF525RequirementsDialogIfNeededAction_BELogin(_authSessionDto : AuthSessionDto){
    if(!_authSessionDto.NF525) return;
    let LS_BE_NF525REQUIREMENTS_ACK = localStorage.getItem(LS_BE_NF525REQUIREMENTS_ACK_KEY) == 'true' ? true : false;
    if(LS_BE_NF525REQUIREMENTS_ACK) return;
    this._matDialog.open(CluNF525RequirementsDialogComponent, {autoFocus: false, disableClose: true, width: '100%', maxWidth: '600px', minHeight: '80vh', maxHeight: '80vh', height : '100%', data : {  authSessionDto : _authSessionDto } })
        .afterClosed()
        .subscribe((res : any) => { if(res){ } });
  }

  async doSwitchToProdEnvironment() {
      const confirmation = await this._confirmationService.showConfirmDialog("Environnement de test", "Êtes-vous sûr de vouloir basculer vers l'environnement de production ? L'application va redémarrer.");
      if (confirmation == true) {
          localStorage.removeItem('LS_BE_SESSION_TEST_ENV');
          location.href = "/cluadmin";
      }
  }
}
